import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-483322ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "score-fun feedback-div"
};
const _hoisted_3 = {
  class: "block",
  style: {
    "align-items": "center",
    "margin-top": "0px"
  }
};
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  class: "demonstration"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_7 = {
  class: "text",
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_8 = {
  style: {
    "flex-direction": "column"
  }
};
const _hoisted_9 = {
  class: "input-txt"
};
const _hoisted_10 = {
  class: "btn-group",
  style: {
    "justify-content": "space-between"
  }
};
const _hoisted_11 = {
  key: 1,
  class: "score-fun scored"
};
const _hoisted_12 = {
  class: "text",
  style: {
    "width": "100%"
  }
};
const _hoisted_13 = {
  style: {
    "width": "80%"
  },
  class: "scorePanel"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_rate = _resolveComponent("el-rate");

  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_button = _resolveComponent("van-button");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [$props.questionRecordSelected ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx._t("inviteScore")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.scoreOption, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_ctx._t(`${item.optionName}`)), 1)]), _createVNode(_component_el_rate, {
      modelValue: item.level,
      "onUpdate:modelValue": $event => item.level = $event,
      max: item.points,
      onClick: $event => $options.clickScore(index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onClick"])]);
  }), 256)), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.scorePanel.optionChecked,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.scorePanel.optionChecked = $event),
    "text-color": "red",
    fill: "green",
    size: "large"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.scoreActive && $options.scoreActive.scoreOption || [], (_option, _optionIndex) => {
      return _openBlock(), _createBlock(_component_el_checkbox, {
        key: _optionIndex,
        label: _option.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_option.content), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
    modelValue: $data.scorePanel.suggestChecked,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.scorePanel.suggestChecked = $event)
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("suggestCheckBox")), 1)]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_field, {
    type: "textarea",
    rows: "3",
    placeholder: _ctx._t('inputSuggest'),
    disabled: !$data.scorePanel.suggestChecked,
    modelValue: $data.scorePanel.suggest,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.scorePanel.suggest = $event),
    maxlength: "100",
    "show-word-limit": ""
  }, null, 8, ["placeholder", "disabled", "modelValue"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
    class: "submit-btn",
    onClick: $options.clickSubmitScore
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("submit")), 1)]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_van_button, {
    class: "return-btn",
    onClick: $options.clickChatAgain
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("chatAgain")), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : $props.scoreSelected ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("inviteScore")), 1)]),
    _: 1
  })]), _createVNode(_component_el_rate, {
    modelValue: $data.scorePanel.level,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.scorePanel.level = $event),
    disabled: "",
    "show-score": "",
    "text-color": "#ff9900",
    "score-template": ""
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_13, [$options.scoreOptionActive && $options.scoreOptionActive.trim() != '' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx._t("yourComments")), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 18
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.scoreOptionActive), 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.scorePanel.suggest && $data.scorePanel.suggest.trim() != '' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx._t("yourSuggest")), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 18
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($data.scorePanel.suggest), 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 512)), [[_vShow, $data.scorePanel.show]]);
}